module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6bfwBJ/tc-custom/9781504075664.jpg?1717877921085",
      "alt": "This image is the cover for the book Quest of the Sacred Slipper"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Quest of the Sacred Slipper\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The theft of a holy relic sets off a deadly plot to reclaim it in this globe-trotting adventure by the author of the Fu-Manchu novels.")])]), _c('p', [_vm._v("Returning to England aboard the S.S. "), _c('i', [_vm._v("Mandalay")]), _vm._v(", a journalist named Cavanagh is struck by an unsettling occurrence at Port Said, Egypt. A wounded beggar is brought aboard—his hand having been cut off—as he carried a professor’s luggage. This brutal episode is only Cavanagh’s first encounter with a merciless network devoted to protecting an ancient Islamic relic: a slipper once worn by the prophet Mohammed.")]), _vm._v(" According to their devout principles, only an anointed few should even touch the slipper or its container. Now, as it makes its way to a British museum, it imperils all those who come in contact with it. But they are not the only ones who want the stolen artifact. Chasing the irresistible story, Cavanagh soon finds himself caught between a murderous cult and a slick American thief in what could be the adventure of his life, if he manages to survive.\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sax Rohmer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sax Rohmer (1883–1959) was a pioneering and prolific author of crime fiction, best known for his series of novels featuring the archetypal evil genius Dr. Fu-Manchu.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media/MysteriousPress\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0